import LegalPage from "./LegalPage";

export default function TermsPage() {
  return (
    <LegalPage title="Terms of Use">
      <p>
        The Cowork Cookbook is provided free, as-is, without warranty of any kind. By using it
        you agree to the following:
      </p>
      <h2>Acceptable use</h2>
      <ul>
        <li>Use recipes responsibly. Many recipes can create or modify data in Dynamics 365 — always test in a sandbox tenant before running in production.</li>
        <li>Do not abuse the rating system (one rating per recipe per anonymous identifier per day).</li>
        <li>Do not attempt to circumvent rate limits or security controls.</li>
      </ul>
      <h2>License</h2>
      <p>
        Recipe content (prose, prompts, taxonomy, BPMN files, screenshots) is licensed under{" "}
        <a href="https://creativecommons.org/licenses/by/4.0/">CC-BY-4.0</a>. Code in recipe skill
        packages is licensed under <a href="https://opensource.org/licenses/MIT">MIT</a> unless a
        recipe specifies otherwise via its <code>recipe.yaml</code> license field. The web app
        code is licensed under MIT.
      </p>
      <h2>Disclaimer of warranties</h2>
      <p>
        The site and its content are provided &quot;as is.&quot; To the maximum extent permitted
        by law, the authors disclaim all warranties, express or implied. You assume full
        responsibility for verifying any recipe produces the expected result in your environment
        before relying on it.
      </p>
      <h2>Limitation of liability</h2>
      <p>
        In no event will the authors or contributors be liable for any indirect, incidental,
        special, consequential, or punitive damages arising out of or related to your use of the
        Cowork Cookbook.
      </p>
    </LegalPage>
  );
}
